import React, { useState } from "react";
import Sidebar from "../../Component/Sidebar";
import { Button } from "antd";
import IMAGES from "../../constants/images";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import EventCounter from "../../Component/EventCounter";
import TabSwitcher from "../../Component/TabSwitcher";
import ViewSwitcher from "../../Component/ViewSwitcher";
import AppointmentControls from "../../Component/AppointmentFilter";
import EventTabSwitcher from "../../Component/EventTabSwitcher";
import EventControl from "../../Component/EventControls";
import { Clock2, Link2, Mail, Phone } from "lucide-react";
export default function Index() {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [activeTab, setActiveTab] = useState("Upcoming");
  const [activeView, setActiveView] = useState("grid");
  const [selectedType, setSelectedType] = useState("all");
  const [filteredAppointment, setFilteredAppointment] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);

  return (
    <div className="flex gap-2 bg-[#F8FAFC] min-h-screen mt-[80px]">
      <div
        className={`hidden lg:flex ${collapsed ? "w-[64px]" : "w-[272px]"} fixed top-0 left-0 h-[calc(100vh/var(--app-zoom))] z-20`}
      >
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>
      <div
        className={`flex-1 min-w-0 bg-[#F8FAFC] pt-2 px-2 pb-8 transition-all duration-300 ${collapsed ? "lg:ml-[64px]" : "lg:ml-[272px]"
          }`}
      >
        <div className="p-4 md:p-6 bg-[#FFFFFF] rounded-2xl">
          {/* Header */}
          <div className="max-w mx-auto p-3">
            <div className="flex items-center justify-between">
              <h1 className="text-lg font-semibold text-[#171717]">
                Disclaimer
              </h1>
            </div>
            <div className="border-t-1 border-[#E2E8F0] mt-0 mb-0" />
          </div>
          <div className="flex flex-col lg:flex-row gap-6 p-3">
            <p className="text-[1E1E1E] text-[16px] font-poppins leading-8">
              Phybercare does not deal with medical or psychological
              emergencies. We are not designed to offer support in crisis
              situations - including when an individual is experiencing thoughts
              of self-harm or suicide, or is showing symptoms of severe clinical
              disorders such as schizophrenia and other psychotic conditions. In
              these cases, in-person medical intervention is the most
              appropriate form of help. If you feel you are experiencing any of
              these difficulties, we would urge you to seek help at the nearest
              hospital or emergency room where you can connect with a
              psychiatrist, social worker, counsellor or therapist in person. We
              recommend you to involve a close family member or a friend who can
              offer support. You can also reach out to a suicide hotline in your
              country of residence:
              http://www.healthcollective.in/contact/helplines
            </p>
          </div>
          <div className="max-w mx-auto p-3">
            <div className="flex items-center justify-between">
              <h1 className="text-lg font-semibold text-[#171717]">
                For Support
              </h1>
            </div>
            <div className="border-t-1 border-[#E2E8F0] mt-0 mb-0" />
          </div>
          <div className="flex h-[30px] items-center flex-col lg:flex-row gap-6 p-3">
            <div className="flex text-[1E1E1E] text-[16px] font-poppins leading-8">
              <Mail className="w-[20] h-[20]" />{" "}
              <span className="ml-2 -mt-1">
                <a href={"mailto:support@phybercare.in"}>
                  support@phybercare.in
                </a>
              </span>
            </div>
            <div className="flex text-[1E1E1E] text-[16px] font-poppins leading-8">
              <Phone className="w-[20] h-[20]" />{" "}
              <span className="ml-2 -mt-1">
                <a href={"tel:+919611077318"}>+91 9611 077 318</a>
              </span>
            </div>
            <div className="flex text-[1E1E1E] text-[16px] font-poppins leading-8">
              <Clock2 className="w-[20] h-[20]" />{" "}
              <span className="ml-2 -mt-1">24X7 Helpline</span>
            </div>
          </div>
          <div className="max-w mx-auto p-3">
            <div className="flex items-center justify-between">
              <h1 className="text-lg font-semibold text-[#171717]">
                Govt. Helpline
              </h1>
            </div>
            <div className="border-t-1 border-[#E2E8F0] mt-0 mb-0" />
          </div>
          <div className="flex h-[30px] items-center flex-col lg:flex-row gap-6 p-3">
            <div className="flex text-[1E1E1E] text-[16px] font-poppins leading-8">
              <Link2 className="w-[20] h-[20]" />{" "}
              <span className="ml-2 -mt-1">
                <a
                  href={"http://www.healthcollective.in/contact/helplines"}
                  target={"_blank"}
                >
                  http://www.healthcollective.in/contact/helplines
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
